import React, { Component } from 'react';

import Header from './Header';
import Sidebar from './Sidebar';
import AppRouter from '../../routers/AppRouter';

import './AppLayout.scss';

export default class Applayout extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        document.documentElement.style.setProperty('--sidebar-width', "300px");
        document.documentElement.style.setProperty('--header-height', "4rem");
    }

    render(){
        return(
            <>
                <Header {...this.props} />
                <Sidebar {...this.props} />
                <div className="content-box">
                    <AppRouter {...this.props} />
                </div>
            </>
        );
    }
}